import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { of } from 'rxjs';
import { catchError, first, switchMap } from 'rxjs/operators';
import { AuthService } from "./auth.service";

export const AuthGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (route.data?.['public']) {
    return true;
  }

  if (state.url.startsWith("/posts/")) {
    return true;
  }

  if (auth.isAuthenticated) return true;


  return auth.refreshToken().pipe(
    first(),
    switchMap(() => {
      if (auth.isAuthenticated) {
        return of(true);
      }

      return of(
        router.createUrlTree(['/login'], {
          queryParams: { redirect: state.url }
        })
      );
    }),
    catchError(() =>
      of(
        router.createUrlTree(['/login'], {
          queryParams: { redirect: state.url }
        })
      )
    )
  );
};
